<script lang="ts">
    import axios from 'axios';
    import Shgrid from '../../components/shgrid/shgrid.svelte';
    import type {Column} from '@/components/shgrid';
    import type {Employee} from  "@/types/types";

    type Row = Employee;

    type Props = {
        view : string;
        onRowClick?: (row: Row) => void;
    };

    let {view, onRowClick  }: Props = $props();


    const getRowLink = (row: Row) => route('employees.show', {employee: row.id});
    const includeLink = view != 'related';
    let cols = $state<Column<Row>[]>([
        {
            label: 'Name',
            key: 'name',
            cellRender: {
                type: 'text',
                label: (row) => row.name,
                ...(includeLink && { link: getRowLink }),
            },
            sortable: true,
            filter: {
                type: 'string',
            },
        },
        {
            label: 'Phone',
            key: 'phone',
            cellRender: {
                type: 'text',
                label: (row) => row.phone ?? "",
                ...(includeLink && { link: getRowLink }),
            },
            sortable: true,
            filter: {
                type: 'string',
            },
        },
        {
            label: 'Email',
            key: 'email',
            cellRender: {
                type: 'text',
                label: (row) => row.email,
                ...(includeLink && { link: getRowLink }),
            },
            sortable: true,
            filter: {
                type: 'string',
            },
        },
        {
            label: 'Charge Hand',
            key: 'charge_hand',
            cellRender: {
                type: 'text',
                label: (row) => row.charge_hand ? 'Yes' : 'No',
            },
            sortable: true,
        },
        {
            label: 'Current Vehicle',
            key: 'active_vehicle',
            cellRender: {
                type: 'text',
                label: (row) => row.active_vehicle?.vehicle?.registration ?? "",
                link: (row) =>  row.active_vehicle?.vehicle ? route('vehicles.show', { vehicle: row.active_vehicle?.vehicle?.id }) : undefined,
                highlightLink: true
            },
            sortable: true,
            filter: {
                type: 'string',
            },
        },
        {
            label: 'Current Job',
            key: 'active_job',
            cellRender: {
                type: 'text',
                label: (row) => row.active_vehicle?.vehicle?.active_job?.job.title ?? "",
                link: (row) =>  row.active_vehicle?.vehicle?.active_job ? route('jobs.show', { job: row.active_vehicle?.vehicle?.active_job?.id }) : undefined,
                highlightLink: true
            },
            sortable: true,
            filter: {
                // type: 'string',
            },
        },
    ]);
</script>

<div>
    <Shgrid
        fetcher={async ({ limit, offset, filters, sorter }) => {
        const res = await axios.get(route('web-api.Employee.index', { limit, offset, filters, sorter }));
        return { data: res.data, error: null };
    }}
        limit={100}
        bind:columns={cols}
        {...(view === 'related' ? { onRowClick } : {})}
    ></Shgrid>
</div>

